var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.2636 9.8637C6.61508 9.51223 7.18492 9.51223 7.5364 9.8637L12 14.3273L16.4636 9.8637C16.8151 9.51223 17.3849 9.51223 17.7364 9.8637C18.0879 10.2152 18.0879 10.785 17.7364 11.1365L12.6364 16.2365C12.4676 16.4053 12.2387 16.5001 12 16.5001C11.7613 16.5001 11.5324 16.4053 11.3636 16.2365L6.2636 11.1365C5.91213 10.785 5.91213 10.2152 6.2636 9.8637Z",
    fill: "#171717",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.bf77462205623c389fce41480247eb87.svg";
export { ForwardRef as ReactComponent };